import showToaster from '../../helpers/toasterMessages/showToaster';
import { userManagement as query, updateBanServiceHistoryStatus as mutation } from '../../lib/graphql';

export const updateBanServiceHistoryStatus = (id, banStatus, userMail, userName, currentPage, searchList, adminMail, userType) => {
    return async (dispatch, getState, { client }) => {

        try {
            const { data } = await client.mutate({
                mutation,
                variables: { id, banStatus },
                fetchPolicy: 'network-only',
                refetchQueries: [{ query, variables: { currentPage, searchList, userType } }]
            });

            if ((data?.updateBanServiceHistoryStatus?.status === "success")) {
                showToaster({ messageId: 'updateBanStatus', toasterType: 'success' })
            } else {
                showToaster({ messageId: 'updateBanStatusFailed', toasterType: 'error' })
            }
        } catch (error) {
            showToaster({ messageId: 'selectBanOrUnBan', toasterType: 'warning' })
            return false;
        }
        return true;
    };
}
